import React from "react";
import Tab from "@visa/vds/tab";
import Icon from "@visa/vds/icon";
import TabLabel from "@visa/vds/tab-label";
import TabAction from "@visa/vds/tab-action";
import { handleVstsButton } from "pages/CertificationWorkflow/SharedComponents/VstsAccessButton";

export const MCSNavPanelTab = {
  TabChild,
  TabMenu,
  TabItem,
  NewTabChildButton,
};

function TabChild(
  iconName,
  tabLabel,
  currentState,
  handleRouting,
  route,
  currentPath = ""
) {
  if (currentState) {
    return (
      <Tab
        onClick={(e, key) => {
          handleRouting(route, key);
        }}
      >
        <TabLabel style={{ paddingLeft: "8px" }}>
          {iconName && <Icon name={iconName} resolution="low" />}
          {tabLabel}
        </TabLabel>
      </Tab>
    );
  }
  return <></>;
}

function NewTabChildButton(
  iconName,
  tabLabel,
  currentState,
) {
    
  // const handleVstsButton = (e) => {
  //   e.stopPropagation();
  //   var windowReference = window.open();
  //   windowReference.opener = null;
  //   windowReference.location = process.env.REACT_APP_VSTS
  //   vstsAccessService.getVstsAccess().then((response) => {
  //     // var windowReference = window.open();
  //     // windowReference.opener = null;
  //     // windowReference.location = process.env.REACT_APP_VSTS;
  //     console.log(response)
  //   }).catch((error) => {
  //     console.error("Error getting VSTS access", error);
  //   });
  // }

  if (currentState) {
    return (
      <>
      <Tab
        onClick={handleVstsButton}
        className={"vds-state--link"}
      >
        <TabLabel style={{ paddingLeft: "8px" }}>
          {iconName && <Icon name={iconName} resolution="low"/>}
          {tabLabel}
        </TabLabel>
      </Tab>
      </>
    );
  }
  return <></>;
}

function TabMenu(iconName, tabLabel, currentState, toggleState) {
  const expandMenu = () => {
    toggleState(!currentState);
  };
  return (
    <Tab onClick={() => expandMenu()}>
      <TabLabel>
        {iconName && <Icon name={iconName} resolution="low" />}
        {tabLabel}
      </TabLabel>
      <TabAction>
        <div onClick={() => expandMenu()}>
          <Icon
            name={currentState ? "arrow-collapse" : "arrow-expand"}
            resolution="tiny"
          />
        </div>
      </TabAction>
    </Tab>
  );
}

function TabItem(iconName, tabLabel, handleRouting, route) {
  return (
    <Tab onClick={(e, key) => handleRouting(route, key)}>
      <TabLabel>
        {iconName && <Icon name={iconName} resolution="low" />}
        {tabLabel}
      </TabLabel>
    </Tab>
  );
}
